import { yieldToMain } from 'js/common/yield-to-main';
import { trackBrowsePageEvent, Category, Property, Action } from './tracking';

export async function toggleQuickview(
  category: Category,
  action: Action.Open | Action.Close
) {
  await yieldToMain();

  trackBrowsePageEvent(category, Property.QuickView, action);
}

export function bttBrowseCardToVenuePage(
  category: Category,
  venueId: string,
  treatmentId: string
): Promise<void> {
  return trackBrowsePageEvent(
    category,
    Property.BestTreatmentInTown,
    Action.Click,
    venueId,
    treatmentId
  );
}

export const trackOpenMapView = () =>
  trackBrowsePageEvent(
    Category.BrowseListResults,
    Property.ToggleToMapButton,
    Action.Click
  );

export async function browseCardToVenuePage(
  category: Category,
  venueId: string
) {
  await yieldToMain();

  trackBrowsePageEvent(
    category,
    Property.GoToVenue,
    Action.Click,
    'listing_card',
    venueId
  );
}

export function trackImageSlider(
  category: Category,
  label: string,
  value: string
): void {
  trackBrowsePageEvent(
    category,
    Property.ImageSlider,
    Action.Click,
    label,
    value
  );
}
